export default __webpack_public_path__ + "static/media/title.5e15fb67.png";